import { Outlet } from 'react-router-dom';
import { AuthProvider } from './auth-context';

/**
 * Scopes the admin session to /admin routes.
 *
 * Mounting AuthProvider globally made every public visitor fire
 * `GET /auth/me`, which answers 401 and logs a console error on the marketing
 * site. Only the admin tree needs a session.
 */
export function AuthBoundary() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}
